import { initContract } from '@ts-rest/core'
import { ErrorResponseSchema } from '../../shared'
import { GetPricingInputSchema, PricingSchema } from './schemas'

const c = initContract()

const pricingOptions = {
  pathPrefix: '/pricing',
  commonResponses: {
    400: ErrorResponseSchema,
    404: ErrorResponseSchema,
    500: ErrorResponseSchema,
  },
}

export const pricingContract = c.router({
  getPrice: {
    method: 'POST',
    path: '/get-price',
    body: GetPricingInputSchema,
    responses: {
      201: PricingSchema,
    },
  },
}, pricingOptions)
